import { render, staticRenderFns } from "./voiture.vue?vue&type=template&id=f8431048&scoped=true&"
import script from "./voiture.vue?vue&type=script&lang=js&"
export * from "./voiture.vue?vue&type=script&lang=js&"
import style0 from "./voiture.vue?vue&type=style&index=0&id=f8431048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8431048",
  null
  
)

export default component.exports